import ReactHtmlParser from 'app/components/base/ReactHtmlParser'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import { HELP_CENTER_SEARCH_ARTICLES_PLACEHOLDER } from 'app/utils/constants/help-center.constants'

import HelpCenterTitle from './components/HelpCenterTitle'

interface HelpCenterDetailArticleFeatureProps {
  title?: string
  body?: string
  isLoading?: boolean
}

const HelpCenterDetailArticleFeature = ({
  title,
  body,
  isLoading
}: HelpCenterDetailArticleFeatureProps) => {
  return (
    <Stack direction="column" spacing={1} sx={{ width: '100%' }}>
      <HelpCenterTitle title={title} isLoading={isLoading} />

      {isLoading &&
        HELP_CENTER_SEARCH_ARTICLES_PLACEHOLDER.articles.map((el) => (
          <Skeleton
            key={el.id}
            loading
            sx={{ width: { xs: '100%', md: '80%' }, height: 24 }}
          />
        ))}

      {!isLoading && <ReactHtmlParser data={String(body)} />}
    </Stack>
  )
}

export default HelpCenterDetailArticleFeature
